import React from 'react';
import CommandOutput from './CommandOutput';

class CommandSuccess extends CommandOutput {
  constructor(command) {
    super();
    this.command = command;
  }

  render() {
    return (
      <span>
        <i className='fa fa-check-circle' />
        &nbsp; Complete: {this.command.name}
      </span>
    );
  }
}

export default CommandSuccess;
